
/* injects from baggage-loader */

/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
*/
(function() {
    CKEDITOR.dialog.add("link", function(g) {
        var l = CKEDITOR.plugins.link,
            m = function() {
                var a = this.getDialog(),
                    b = a.getContentElement("target", "popupFeatures"),
                    a = a.getContentElement("target", "linkTargetName"),
                    k = this.getValue();
                if (b && a) switch (b = b.getElement(), b.hide(), a.setValue(""), k) {
                    case "frame":
                        a.setLabel(g.lang.link.targetFrameName);
                        a.getElement().show();
                        break;
                    case "popup":
                        b.show();
                        a.setLabel(g.lang.link.targetPopupName);
                        a.getElement().show();
                        break;
                    default:
                        a.setValue(k), a.getElement().hide()
                }
            },
            f = function(a) {
                a.target && this.setValue(a.target[this.id] || "")
            },
            h = function(a) {
                a.advanced && this.setValue(a.advanced[this.id] || "")
            },
            i = function(a) {
                a.target || (a.target = {});
                a.target[this.id] = this.getValue() || ""
            },
            j = function(a) {
                a.advanced || (a.advanced = {});
                a.advanced[this.id] = this.getValue() || ""
            },
            c = g.lang.common,
            b = g.lang.link,
            d;
        return {
            title: b.title,
            minWidth: 200,
            minHeight: 85,
            contents: [{
                id: "info",
                label: b.info,
                title: b.info,
                elements: [{
                    id: "linkType",
                    type: "select",
                    label: b.type,
                    "default": "url",
                    items: [
                        [b.toUrl, "url"],
                        [b.toAnchor, "anchor"],
                        [b.toEmail, "email"]
                    ],
                    onChange: function() {
                        var a = this.getDialog(),
                            b = ["urlOptions", "anchorOptions", "emailOptions"],
                            k = this.getValue(),
                            e = a.definition.getContents("upload"),
                            e = e && e.hidden;
                        "url" == k ? (g.config.linkShowTargetTab && a.showPage("target"), e || a.showPage("upload")) : (a.hidePage("target"), e || a.hidePage("upload"));
                        for (e = 0; e < b.length; e++) {
                            var c = a.getContentElement("info", b[e]);
                            c && (c = c.getElement().getParent().getParent(), b[e] == k + "Options" ? c.show() : c.hide())
                        }
                        a.layout()
                    },
                    setup: function(a) {
                        this.setValue(a.type ||
                            "url")
                    },
                    commit: function(a) {
                        a.type = this.getValue()
                    }
                }, {
                    type: "vbox",
                    id: "urlOptions",
                    children: [{
                        type: "hbox",
                        children: [{
                            type: "text",
                            id: "url",
                            required: !0,
                            onLoad: function() {
                                this.allowOnChange = !0
                            },
                            onKeyUp: function() {
                                this.allowOnChange = !1;
                                var a = this.getDialog().getContentElement("info", "protocol"),
                                    b = this.getValue(),
                                    k = /^((javascript:)|[#\/\.\?])/i,
                                    c = /^(http|https|ftp|news):\/\/(?=.)/i.exec(b);
                                c ? (this.setValue(b.substr(c[0].length)), a.setValue(c[0].toLowerCase())) : k.test(b) && a.setValue("");
                                this.allowOnChange = !0
                            },
                            onChange: function() {
                                if (this.allowOnChange) this.onKeyUp()
                            },
                            validate: function() {
                                var a = this.getDialog();
                                return a.getContentElement("info", "linkType") && "url" != a.getValueOf("info", "linkType") ?
                                    !0 : !g.config.linkJavaScriptLinksAllowed && /javascript\:/.test(this.getValue()) ? (alert(c.invalidValue), !1) : this.getDialog().fakeObj ? !0 : CKEDITOR.dialog.validate.notEmpty(b.noUrl).apply(this)
                            },
                            setup: function(a) {
                                this.allowOnChange = !1;
                                a.url && this.setValue(a.url.url);
                                this.allowOnChange = !0
                            },
                            commit: function(a) {
                                this.onChange();
                                a.url || (a.url = {});
                                a.url.url = this.getValue();
                                this.allowOnChange = !1
                            }
                        }],
                        setup: function() {
                            this.getDialog().getContentElement("info", "linkType") || this.getElement().show()
                        }
                    }, {
                        type: "button",
                        id: "browse",
                        hidden: "true",
                        filebrowser: "info:url",
                        label: c.browseServer
                    }]
                }]
            },{
                id: "target",
                elements: [{
                    type: "hbox",
                    widths: ["50%", "50%"],
                    children: [{
                        type: "checkbox",
                        id: "linkTargetType",
                        label: c.target,
                        items: [
                            [c.targetNew, "_blank"]
                        ],
                        onChange: m,
                        setup: function(a) {
                            a.target && this.setValue(a.target.type || "notSet");
                            m.call(this)
                        },
                        commit: function(a) {
                            a.target || (a.target = {});
                            a.target.type = this.getValue()
                        }
                    }]
                }]
            }],
            onShow: function() {
                var a =
                    this.getParentEditor(),
                    b = a.getSelection(),
                    c = null;
                (c = l.getSelectedLink(a)) && c.hasAttribute("href") ? b.getSelectedElement() || b.selectElement(c) : c = null;
                a = l.parseLinkAttributes(a, c);
                this._.selectedElement = c;
                this.setupContent(a)
            },
            onOk: function() {
                var a = {};
                this.commitContent(a);
                var b = g.getSelection(),
                    c = l.getLinkAttributes(g, a);
                if (this._.selectedElement) {
                    var e = this._.selectedElement,
                        d = e.data("cke-saved-href"),
                        f = e.getHtml();
                    e.setAttributes(c.set);
                    e.removeAttributes(c.removed);
                    if (d == f || "email" == a.type && -1 !=
                        f.indexOf("@")) e.setHtml("email" == a.type ? a.email.address : c.set["data-cke-saved-href"]), b.selectElement(e);
                    delete this._.selectedElement
                } else b = b.getRanges()[0], b.collapsed && (a = new CKEDITOR.dom.text("email" == a.type ? a.email.address : c.set["data-cke-saved-href"], g.document), b.insertNode(a), b.selectNodeContents(a)), c = new CKEDITOR.style({
                    element: "a",
                    attributes: c.set
                }), c.type = CKEDITOR.STYLE_INLINE, c.applyToRange(b, g), b.select()
            },
            onLoad: function() {
                g.config.linkShowAdvancedTab || this.hidePage("advanced");
                g.config.linkShowTargetTab ||
                    this.hidePage("target")
            },
            onFocus: function() {
                var a = this.getContentElement("info", "linkType");
                a && "url" == a.getValue() && (a = this.getContentElement("info", "url"), a.select())
            }
        }
    })
})();



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/link/dialogs/link.js